import React from "react"
import { TagBox, Template } from "devextreme-react";
import { renderDropdownIcon } from "../../commonFunctions/commonFunctions";


function CustomTagBox(props){

    return(
    <TagBox
    {...props}
    ref={props.innerRef}
    showDropDownButton
    labelMode="floating"
    dropDownButtonTemplate="dropdownIcon"
    >
        <Template
            name="dropdownIcon"
            render={renderDropdownIcon}
        />
    </TagBox>
    )
}

export default CustomTagBox